import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/admin-kirei/fontawesome-free/css/all.min.css'
import './assets/highlight-style/scss/highlight.css'
import './assets/VueAgile.css'
import moment from 'moment'
import axios from 'axios'
//notification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css"

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true
});


// get token, and autohrization for access API with token / ambil token dilocal storage dan security dengan guard token untuk ngambil API
axios.defaults.headers.common['x-token'] = `${localStorage.token}`
// api path di axios
axios.defaults.baseURL = "https://portal.kirei.co.id/api/v1/"




Vue.prototype.moment = moment

// Vue.prototype.$url_path = "http://localhost:8080/"
Vue.prototype.$url_path = "https://highlight.kirei.co.id/"

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js